<form [formGroup]="camSpecificationForm">
  <div class="w-full flex flex-row items-center justify-between">
    <div class="justify-self-start">
      <h2 class="m-0" id="cam-spec-heading">{{ translationService.translate('createCAMSpecHeadingText') }}</h2>
    </div>

    <div class="create-screen-button-container">
      @if (showDiscardButton) {
      <button id="discard-button" type="button" mat-flat-button class="mic-btn-icon-left" (click)="discard()">
        <mat-icon>delete</mat-icon>
        {{ translationService.translate('discardButtonText') }}
      </button>
      } @if (showBackButton) {
      <button id="back-button" type="button" mat-flat-button class="mic-btn-icon-left" (click)="back()">
        <mat-icon>arrow_back</mat-icon>
        {{ translationService.translate('backButtonText') }}
      </button>
      } @if (showContinueButton) {
      <button
        id="continue-button"
        type="button"
        mat-flat-button
        color="primary"
        class="mic-btn-icon-left"
        (click)="continue()"
        [loading]="continueProcessing"
      >
        <mat-icon>arrow_forward</mat-icon>
        {{ translationService.translate('continueButtonText') }}
      </button>
      } @if (showSaveButton) {
      <button
        id="save-button"
        type="button"
        mat-flat-button
        color="primary"
        class="mic-btn-icon-left"
        (click)="save()"
        [loading]="saveProcessing"
      >
        <mat-icon>save</mat-icon>
        {{ translationService.translate('saveLinkText') }}
      </button>
      }
    </div>
  </div>

  <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="saveProcessing">
    <mat-card class="custom-card-no-shadow mt-5 {{ textFieldClass }}" appearance="outlined">
      <div class="w-full flex flex-row items-center justify-between gap-3">
        <div class="justify-self-start gap-3 px-5 py-2">
          <mat-form-field class="mr-5" subscriptSizing="dynamic" id="cam-spec-name-field">
            <mat-label>{{ translationService.translate('camSpecNameText') }}</mat-label>
            <input matInput type="text" placeholder="" [formControlName]="'specCode'" required [readonly]="!createMode" />
            @if (camSpecificationForm.get('specCode').hasError('required')) {
            <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
            } @if (camSpecificationForm.get('specCode').hasError('alreadyExists')) {
            <mat-error>{{ translationService.translate('invalidCamSpecName') }}</mat-error>
            } @if (camSpecificationForm.get('specCode').hasError('invalidSpecCode')) {
            <mat-error>{{ translationService.translate('cannotStartWithBtText') }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="mr-5" subscriptSizing="dynamic" id="cam-spec-description-field">
            <mat-label>{{ translationService.translate('camSpecDescText') }}</mat-label>
            <input matInput type="text" placeholder="" [formControlName]="'specDescription'" required [readonly]="!createMode" />
            @if (camSpecificationForm.get('specDescription').hasError('required')) {
            <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="mr-5" subscriptSizing="dynamic" id="cam-spec-type-field">
            <mat-label>{{ translationService.translate('camSpecTypeText') }}</mat-label>
            <input matInput type="text" placeholder="" [formControlName]="'specType'" required readonly />
            @if (camSpecificationForm.get('specType').hasError('required')) {
            <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </mat-card>

    @if (showCreateSpecificationForm) {
    <mat-card class="custom-card-no-shadow create-cam-mat-card mt-5" appearance="outlined">
      <div class="max-h-full">
        <mic-sidebar-container class="flex flex-row" leftToggler="create-cam-spec-line-toggler">
          <mic-sidebar position="start" mode="large">
            @for (line of specificationLines.controls; track line; let i = $index) {
            <div>
              <mic-sidebar-item
                id="spec-line-label-{{ i }}"
                class="spec-line-label"
                link="{{ specificationLink(line.get('lineIndex').value) }}"
                label="{{
                  line.get('label').value === 'Default RR'
                    ? translationService.translate('defaultRRText')
                    : line.get('label').value === 'Default RO'
                    ? translationService.translate('defaultROText')
                    : line.get('label').value
                }}"
                [ngClass]="{ 'spec-line-label': true, 'disable-sidebar': createMode === true }"
                (keydown.enter)="disable_key_sidebar($event)"
              >
              </mic-sidebar-item>
            </div>
            }
          </mic-sidebar>
          <mic-main-content main>
            <div id="spec-line" class="flex flex-col fill justify-between" content>
              <!-- Toggler only appears at mobile breakpoints; lets users open the
                   spec-line list so the line detail can use full width. -->
              <mic-sidebar-toggler id="create-cam-spec-line-toggler" [alwaysDisplay]="false" class="mb-2"></mic-sidebar-toggler>
              <mat-card class="custom-card-no-shadow create-cam-line-mat-card">
                <router-outlet></router-outlet>
              </mat-card>
            </div>
          </mic-main-content>
        </mic-sidebar-container>
      </div>
    </mat-card>
    }
  </mic-spinner-overlay>
</form>

<mic-modal #createComponentModal (result)="onConfirmationModalClosed($event)"></mic-modal>

<ng-template #createComponentContentModal>
  Are you sure you want to leave this screen and discard your changes? This action cannot be undone.
</ng-template>
